import React from 'react';
import { Typography } from '@mui/material';
import { formatMessage, Store, ACTIVE_SCREEN_KEY } from 'cw-ui-core';
import Locale from 'src/i18n';
import loadAllNotifications from 'src/services/NotificationsService';
import { FETCH_NOTIFICATION_INTERVAL } from 'src/features/notifications/constants';

export const handleErrorAndEmptyStateMsg = isError => {
    if (isError) {
        return [
            <Typography variant="h4" color="text.textPrimary">
                {formatMessage(Locale.NotificationError)}
            </Typography>,
            <Typography align="center">{formatMessage(Locale.NotificationErrorMSg)}</Typography>,
        ];
    }
    return [
        <Typography variant="h4" color="text.textPrimary">
            {formatMessage(Locale.NotificationEmpty)}
        </Typography>,
        <Typography align="center">{formatMessage(Locale.NotificationEmptyMsg)}</Typography>,
    ];
};

export const handleErrorAndEmptyStateImg = (error, empty) => {
    if (error) {
        return 'images/Notification_Error.svg';
    }
    if (empty) {
        return 'images/Empty_State_Notifications.svg';
    }
    return '';
};

const formatDate = dateTime => {
    const utcDate = new Date(dateTime);
    const day = `0${utcDate.getDate()}`.slice(-2);
    const year = `${utcDate.getFullYear()}`;
    const month = `${utcDate.toLocaleString('default', { month: 'short' })}`;
    const hours = `0${utcDate.getHours()}`.slice(-2);
    const minutes = `0${utcDate.getMinutes()}`.slice(-2);
    const seconds = `0${utcDate.getSeconds()}`.slice(-2);
    const formattedDate = `On ${day} ${month}, ${year} ${hours}:${minutes}:${seconds}`;
    return formattedDate;
};
export const fetchNotificationUtils = async () => {
    await Store().runSaga(loadAllNotifications, ACTIVE_SCREEN_KEY).toPromise();
    setTimeout(fetchNotificationUtils, FETCH_NOTIFICATION_INTERVAL);
};

export default formatDate;
